<template>
  <v-row class="mt-3" :class="{'error-terms-checkbox': showTermsError}">
    <v-col>
      <v-checkbox
        v-model="termsAccepted"
        :rules="requireValidation ? [rules.required] : []"
        :error="showTermsError"
        :error-messages="errorMessages"
        class="mt-4"
        @change="saveTermsPreference"
        v-if="showTermsCheckbox"
      >
        <template v-slot:label>
          <v-row>
            <v-col align="start">
              <span class="">
                {{ $t('termsAgreement') }}
                <a href="#" class="text-decoration-none terms-link" @click.prevent="openPrivacy">
                  {{ $t('privacyPolicy') }}
                </a>
              </span>
            </v-col>
          </v-row>
        </template>
      </v-checkbox>
    </v-col>
  </v-row>
</template>

<script>
import rules from "@/helpers/rules";

export default {
  name: "TermsAgreementCheckbox",
  props: {
    requireValidation: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      termsAccepted: false,
      showTermsCheckbox: true,
      showTermsError: false,
      errorMessages: "",
      rules
    };
  },
  mounted() {
    // Check if user has already accepted terms
    const termsAccepted = localStorage.getItem('termsAccepted');
    if (termsAccepted == 'true') {
      this.$store.commit('SET_TERMS_ACCEPTED', true);
      this.termsAccepted = true;
      this.showTermsCheckbox = false;
    } 
    else {
      this.showTermsCheckbox = true;
    }
  },
  methods: {
    saveTermsPreference(event) {
      this.$store.commit('SET_TERMS_ACCEPTED', this.termsAccepted);
      if (this.termsAccepted) {
        this.showTermsError = false;
        this.errorMessages = '';
      }
      
      // Save to localStorage
      localStorage.setItem('termsAccepted', this.termsAccepted.toString());
      
      // Emit the change to parent component
      this.$emit('terms-changed', this.termsAccepted);
    },
    handleTermsNotAccepted() {
      this.showTermsError = true;
      this.errorMessages = this.$t('termsAcceptanceError');
    },
    // Public method for external access to terms status
    getTermsAccepted() {
      return this.termsAccepted;
    },
    // Public method for external validation
    validateTerms() {
      if (!this.termsAccepted) {
        this.handleTermsNotAccepted();
        return false;
      }
      return true;
    },
    openPrivacy() {
      window.open('/privacy-policy', '_blank');
    }
  }
};
</script>

<style scoped>
.v-input--selection-controls {
  margin-top: 0 !important;
}

.terms-link {
  color: #1976d2 !important;
  font-weight: 500 !important;
  text-decoration: underline !important;
}

.terms-link:hover {
  color: #1565c0 !important;
  text-decoration: none !important;
}

.error-terms-checkbox {
  border: 2px solid #f44336 !important;
  border-radius: 4px !important;
  background-color: rgba(244, 67, 54, 0.1) !important;
}

.terms-checkbox-error ::v-deep .v-label {
  color: #f44336 !important;
  font-weight: 500 !important;
}
</style>